const StoryTypes = Object.freeze({
  SOCIAL_MEDIA_POST: 'SocialMediaPost',
  STORY: 'Story',
});

export default StoryTypes;
